(function () {
  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant || !data.sectionId) return;

      var color = data.variant.options && data.variant.options[0];
      if (!color) return;

      applyColorFilter(data.sectionId, color);
    });
  }

  function applyColorFilter(sectionId, color) {
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return;

    var items = gallery.querySelectorAll('[data-media-color]');

    items.forEach(function (item) {
      var itemColor = item.getAttribute('data-media-color');
      var shouldShow = itemColor === '' || itemColor === color;
      item.classList.toggle('variant-color-hidden', !shouldShow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
